export const INITIATE_IMPERSONATION = 'INITIATE_IMPERSONATION';
export const INITIATE_IMPERSONATION_SUCCESS = 'INITIATE_IMPERSONATION_SUCCESS';
export const INITIATE_IMPERSONATION_FAILURE = 'INITIATE_IMPERSONATION_FAILURE';

export const GET_IMPERSONATION_USERDATA = 'GET_IMPERSONATION_USERDATA';
export const GET_IMPERSONATION_USERDATA_SUCCESS =
    'GET_IMPERSONATION_USERDATA_SUCCESS';
export const GET_IMPERSONATION_USERDATA_FAILURE =
    'GET_IMPERSONATION_USERDATA_FAILURE';

export const GET_LOGGED_USERDATA = 'GET_LOGGED_USERDATA';
export const GET_LOGGED_USERDATA_SUCCESS = 'GET_LOGGED_USERDATA_SUCCESS';
export const GET_LOGGED_USERDATA_FAILURE = 'GET_LOGGED_USERDATA_FAILURE';

export const INVALIDATE_IMPERSONATION = 'INVALIDATE_IMPERSONATION';
export const INVALIDATE_IMPERSONATION_SUCCESS =
    'INVALIDATE_IMPERSONATION_SUCCESS';
export const INVALIDATE_IMPERSONATION_FAILURE =
    'INVALIDATE_IMPERSONATION_FAILURE';

export const SET_BANNER = 'SET_BANNER';
export const SET_ERROR = 'SET_ERROR';
export const RESET_IMPERSONATION_ERROR = 'RESET_IMPERSONATION_ERROR';
export const CHECK_IMPERSONATION_ACTIVE = 'CHECK_IMPERSONATION_ACTIVE';

export const setImpersonateCheckAction = (isImpersonationActive) => {
    return {
        type: CHECK_IMPERSONATION_ACTIVE,
        payload: isImpersonationActive,
    };
};

export const initiateImpersonation = () => {
    return {
        type: INITIATE_IMPERSONATION,
    };
};

export const getImpersonationUserData = () => {
    return {
        type: GET_IMPERSONATION_USERDATA,
    };
};

export const invalidateImpersonation = () => {
    return {
        type: INVALIDATE_IMPERSONATION,
    };
};

export const setBanner = (value) => {
    return {
        type: SET_BANNER,
        payload: value,
    };
};
export const setError = () => {
    return {
        type: SET_ERROR,
    };
};

export const resetImpersonationError = () => {
    return {
        type: RESET_IMPERSONATION_ERROR,
    };
};
